/* eslint-disable import/prefer-default-export */
import { inject } from 'vue';

import { SpacingType } from '@constants/spacing';

type UseSpacingType = { spacing: SpacingType };
type UseSpacingFunctionType = () => UseSpacingType;

export const useSpacing: UseSpacingFunctionType = () => {
  const spacing = inject<SpacingType>('$spacing');
  return { spacing } as UseSpacingType;
};
